import * as React from "react";
import {createApiClient, IApiClient} from "src/infra/api/client";
import {createPublicAPI} from "src/infra/api/service/public_api";
import {createOccupationSkillTagAPI} from "src/infra/api/service/skill_tag_api";
import {ClientBookmark} from "../../../../domain/model/client_bookmark";
import {Company} from "../../../../domain/model/company";
import {Customer} from "../../../../domain/model/customer";
import {JobCareer} from "../../../../domain/model/job_career";
import {PastCaseProject} from "../../../../domain/model/past_case_project";
import {Project} from "../../../../domain/model/project";
import {SearchHighlight} from "../../../../domain/model/search_highlight";
import {OccupationSkillTag} from "../../../../domain/model/skill_tag";
import {TJobCareerWithCustomerID} from "../../../../domain/repository/job_career_repository";
import {IOccupationSkillTagRepository} from "../../../../domain/repository/skill_tag_repository";
import Progress from "../../../common/organism/progress";
import {PageMode} from "../../../container/client_scout_customer_container";
import ClientScoutCustomerFirstComponent from "./client_scout_customer_first";
import ClientScoutCustomerSecondComponent from "./client_scout_customer_second";
import ClientScoutCustomerThirdComponent from "./client_scout_customer_third";

interface IProps {
    isLoading: boolean;
    isInit: boolean;
    customer: Customer | null;
    company: Company | null;
    defaultText: string;
    sameOccupationCustomers: Customer[];
    jobCareersWithSameOccupationCustomerID: TJobCareerWithCustomerID[];
    jobCareers: JobCareer[];
    pastCaseProjects: PastCaseProject[];
    projects: Project[];
    clientBookmarks: ClientBookmark[];
    highlights: SearchHighlight[];
    pageMode: PageMode;
    isClientBookmark: boolean;
    handleCreateScout: (values: any) => void;
    handleNextStep: (values: any) => void;
    handlePreviousStep: (values: any) => void;
    handleCreateClientBookmark: (event: any) => void;
    handleDeleteClientBookmark: (event: any) => void;
}

const apiClient: IApiClient = createApiClient();
const occupationSkillTagRepository: IOccupationSkillTagRepository =
    createOccupationSkillTagAPI(apiClient);
const publicAPI = createPublicAPI(apiClient);

const ClientScoutCustomerComponent: React.FC<IProps> = (props) => {
    const {
        isInit,
        isLoading,
        pageMode,
        customer,
        sameOccupationCustomers,
        jobCareersWithSameOccupationCustomerID,
        company,
        defaultText,
        jobCareers,
        pastCaseProjects,
        projects,
        clientBookmarks,
        isClientBookmark,
        handleCreateScout,
        handleNextStep,
        handlePreviousStep,
        handleCreateClientBookmark,
        handleDeleteClientBookmark,
        highlights,
    } = props;

    const [occupationSkillTags, setOccupationSkillTags] = React.useState<
        OccupationSkillTag[]
    >([]);

    React.useEffect(() => {
        try {
            publicAPI
                .getAllOccupationSkillTag({
                    id: "",
                    pager: {
                        page: 1,
                        offset: 1000000,
                    },
                })
                .then((items) => {
                    setOccupationSkillTags(items);
                });
        } catch (e) {

        }
    }, []);

    // 初期化
    if (isInit) {
        return <Progress canAnimation={false}/>;
    }

    let res: JSX.Element;

    switch (pageMode) {
        case PageMode.StepScoutStep1: {
            res = (
                <ClientScoutCustomerFirstComponent
                    isLoading={isLoading}
                    customer={customer}
                    company={company}
                    sameOccupationCustomers={sameOccupationCustomers}
                    jobCareersWithSameOccupationCustomerID={
                        jobCareersWithSameOccupationCustomerID
                    }
                    jobCareers={jobCareers}
                    highlights={highlights}
                    pastCaseProjects={pastCaseProjects}
                    clientBookmarks={clientBookmarks}
                    isClientBookmark={isClientBookmark}
                    handleNextStep={handleNextStep}
                    handleCreateClientBookmark={handleCreateClientBookmark}
                    handleDeleteClientBookmark={handleDeleteClientBookmark}
                    occupationSkillTags={occupationSkillTags}
                />
            );

            break;
        }
        case PageMode.StepScoutStep2: {
            res = (
                <ClientScoutCustomerSecondComponent
                    projects={projects}
                    handleNextStep={handleNextStep}
                    handlePreviousStep={handlePreviousStep}
                />
            );

            break;
        }
        case PageMode.StepScoutStep3: {
            res = (
                <ClientScoutCustomerThirdComponent
                    projects={projects}
                    jobCareers={jobCareers}
                    defaultText={defaultText}
                    handleCreateScout={handleCreateScout}
                    handlePreviousStep={handlePreviousStep}
                />
            );

            break;
        }

        default:
            return <div/>;
    }

    return res;
};

export default ClientScoutCustomerComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer.tsx